var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"height":"100%","width":"100%","min-height":"1000px"},attrs:{"src":"http://localhost:62620/ReportViewer.aspx?quoteID=0","frameborder":"0","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }